import React from "react";
import { ICellRendererParams } from "@ag-grid-community/core";
import { useTranslation } from "react-i18next";

import { TransferListItem } from "../../../../types";
import { InvoiceableIndicator, PaperFormIndicator } from "../../../index";

import styles from "./TypeGridCell.module.scss";

interface Props extends ICellRendererParams {
  data: TransferListItem;
  isInternal?: boolean;
}

const TypeGridCell = (props: Props) => {
  const { data, isInternal } = props;
  const { t } = useTranslation();

  return (
    <div className={styles.transferType}>
      {t(`transfers.type.${data.transferType}`)}
      <PaperFormIndicator isPaperForm={data.isPaperForm} />
      {!isInternal && (
        <InvoiceableIndicator isInvoiceable={data.isInvoiceable} />
      )}
    </div>
  );
};

export default TypeGridCell;
